/**
 * TargetingCursor - Glowing reticle that follows the mouse when targeting is active.
 * Shown when a unit has a deploy effect (or other order) that requires picking a target.
 * Uses pointer-events: none so it does not block clicks.
 */

import React, { useState, useEffect } from 'react';
import './TargetingCursor.css';

export function TargetingCursor({ active }) {
  const [position, setPosition] = useState(null);

  useEffect(() => {
    if (!active) {
      setPosition(null);
      return;
    }

    const handleMove = (e) => {
      setPosition({ x: e.clientX, y: e.clientY });
    };

    // Show at center until first mousemove so cursor is visible immediately when entering targeting
    setPosition((prev) => prev ?? { x: typeof window !== 'undefined' ? window.innerWidth / 2 : 0, y: typeof window !== 'undefined' ? window.innerHeight / 2 : 0 });

    window.addEventListener('mousemove', handleMove);

    return () => {
      window.removeEventListener('mousemove', handleMove);
    };
  }, [active]);

  if (!active) return null;

  return (
    <div className="targeting-cursor-overlay" aria-hidden="true">
      {position && (
        <div
          className="targeting-cursor-reticle"
          style={{
            left: position.x,
            top: position.y,
          }}
        >
          <div className="targeting-cursor-ring" />
          <div className="targeting-cursor-dot" />
        </div>
      )}
    </div>
  );
}

export default TargetingCursor;
